import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const FormRoot = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;

export const FormField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
`;

export const FormLabel = styled.label`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 500;
	line-height: 1.4;
`;

export const fieldStyles = `
	width: 100%;
	box-sizing: border-box;
	border-radius: 8px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	line-height: 1.2;
	outline: none;
	transition: border-color 0.2s ease;

	&:focus {
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
	}

	&::placeholder {
		color: ${BTTO_PROFILE_COLORS.textDim};
	}
`;

export const FormInput = styled.input`
	${fieldStyles}
	height: 44px;
	padding: 0 14px;
`;

export const FormActions = styled.div`
	display: flex;
	width: 100%;
	padding-top: 4px;
`;
